import { Question } from './question.js';

export class MultiSelectQuestion extends Question {
    constructor(question, ctx) {
        super(question, ctx);
        this.answer = [];
    }

    renderContent() {
        this.ctx.elementIds.push('answerOptionsElement' + this.question.id);
        let answerName = [];
        let questionAnswers = this.ctx.changeAnswerOptionsSequence(this.question.answers, this.question.randomType);

        let answerOptionsElement = document.createElement('div');
        answerOptionsElement.style.marginTop = '16px';
        answerOptionsElement.classList.add('ph-options');
        answerOptionsElement.id = 'answerOptionsElement' + this.question.id;

        let internalBox = document.createElement('div');
        internalBox.classList.add('ph-survey__inner');
        internalBox.setAttribute('role', 'group');
        internalBox.setAttribute('aria-labelledby', 'ph-title-' + this.question.id);
        this.answerContainer = internalBox;

        let warningElement = document.createElement('div');
        warningElement.id = 'warningElement' + this.question.id;
        warningElement.classList.add('ph-warning');
        warningElement.style.display = 'none';
        warningElement.style.marginBottom = '12px';
        answerOptionsElement.appendChild(warningElement);

        answerOptionsElement.appendChild(internalBox);

        if (questionAnswers.length > 6) {
            internalBox.style.padding = '0 12px 0px 0px';
        }

        questionAnswers.forEach((option, index) => {
            if (option.type === 'normal' && option.content !== null) {
                let answerOption = document.createElement('div');
                let label = document.createElement('label');
                label.htmlFor = 'answer' + this.ctx.currentIndex + index;
                label.textContent = option.content;
                label.style.textAlign = 'left';
                answerOption.classList.add('ph-option');
                let selectBox = document.createElement('input');
                selectBox.type = 'checkbox';
                selectBox.classList.add('ph-input--checkbox');
                selectBox.id = 'answer' + this.ctx.currentIndex + index;
                selectBox.name = 'answer';
                selectBox.value = option.content;

                answerOption.setAttribute('tabindex', '0');
                selectBox.setAttribute('tabindex', '-1');
                answerOption.addEventListener('keydown', (e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        answerOption.click();
                    }
                });

                answerOption.appendChild(selectBox);
                answerOption.appendChild(label);

                answerOption.onclick = (event) => {
                    if (event.target !== selectBox && event.target !== label && !selectBox.disabled) {
                        selectBox.checked = !selectBox.checked;
                        selectBox.dispatchEvent(new Event('click'));
                    }
                };

                selectBox.onclick = () => {
                    if (this.answer.length === 0) {
                        this.answer[0] = option.content;
                        answerName[0] = option.content;
                    } else {
                        selectBox.checked ? this.answer.push(option.content) : this.answer.splice(this.answer.indexOf(option.content), 1);
                        selectBox.checked ? answerName.push(option.content) : answerName.splice(answerName.indexOf(option.content), 1);
                    }
                    this.updateSelectionState();
                    this.ctx.updateAnswers(this.question, this.answer);
                };
                internalBox.appendChild(answerOption);
            } else if (option.type === 'other') {
                let answerOption = document.createElement('div');
                let label = document.createElement('label');
                label.htmlFor = 'answer' + this.ctx.currentIndex + index;
                label.textContent = option.name;
                label.style.textAlign = 'left';
                answerOption.classList.add('ph-option');
                label.id = 'label' + 'multi_select' + this.question.id + index;
                let selectBox = document.createElement('input');
                selectBox.type = 'checkbox';
                selectBox.classList.add('ph-input--checkbox');
                selectBox.id = 'answer' + this.ctx.currentIndex + index;
                selectBox.name = 'answer';
                selectBox.value = option.name;

                answerOption.setAttribute('tabindex', '0');
                selectBox.setAttribute('tabindex', '-1');
                answerOption.addEventListener('keydown', (e) => {
                    if (e.target !== answerOption) return;
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        answerOption.click();
                    }
                });

                answerOption.appendChild(selectBox);
                answerOption.appendChild(label);

                answerOption.onclick = (event) => {
                    if (event.target !== selectBox && event.target !== label && !selectBox.disabled && event.target.tagName !== 'INPUT') {
                        selectBox.checked = !selectBox.checked;
                        selectBox.dispatchEvent(new Event('click'));
                    }
                };

                selectBox.onclick = () => {
                    const labelEl = this.ctx.getById(this.shadowRoot, 'label' + 'multi_select' + this.question.id + index);
                    let input = this.ctx.getById(this.shadowRoot, 'multi_answer' + this.ctx.currentIndex + index);

                    if (selectBox.value) {
                        selectBox.checked ? this.answer.push(selectBox.value) : this.answer.splice(this.answer.indexOf(selectBox.value), 1);
                        selectBox.checked ? answerName.push(option.name) : answerName.splice(answerName.indexOf(option.name), 1);
                    }

                    if (!selectBox.checked) {
                        if (input)
                            if (input.value === '') {
                                input.style.display = 'none';
                                if (labelEl) {
                                    labelEl.style.display = 'block';
                                }
                            }
                        input.blur();
                    } else {
                        if (input) {
                            input.style.display = 'block';
                            input.focus();
                        }
                        if (labelEl) {
                            labelEl.style.display = 'none';
                        }
                    }

                    if (answerOption.childNodes.length < 3) {
                        let input = document.createElement('input');
                        input.classList.add('ph-input--text-inline');
                        input.type = 'text';
                        input.id = 'multi_answer' + this.ctx.currentIndex + index;
                        input.name = 'answer';
                        input.placeholder = option.placeholder;
                        input.setAttribute('aria-label', 'Other answer');
                        input.classList.add('ph-option');
                        input.style.padding = '0px';
                        input.style.minHeight = '20px';
                        input.style.backgroundColor = 'transparent';

                        answerOption.appendChild(input);
                        input.focus();

                        input.addEventListener('input', () => {
                            if (this.answer.length === 0) {
                                this.answer[0] = selectBox.value;
                                answerName[0] = option.name;
                            } else if (selectBox.checked) {
                                this.answer[this.answer.indexOf(selectBox.value)] = input.value;
                                selectBox.value = input.value;
                            }
                            this.ctx.updateAnswers(this.question, this.answer);
                        });
                    }
                    this.updateSelectionState();
                };

                internalBox.appendChild(answerOption);
            }
        });

        return answerOptionsElement;
    }

    renderNextButton() {
        let nextButton = document.createElement('button');
        nextButton.classList.add('ph-btn--primary');
        nextButton.textContent = this.question.buttonName;
        nextButton.addEventListener('click', () => {
            const setNum = this.question.setNumberOfAnswers === '1' || this.question.setNumberOfAnswers === 1 || this.question.setNumberOfAnswers === true ? true : false;
            const min = setNum ? (this.question.numberOfMinAnswers || 1) : 1;
            const max = setNum ? (this.question.numberOfMaxAnswers || 2) : (this.question.numberOfMaxAnswers || '');
            const lang = this.ctx.language || 'de';
            
            const hasEmptyAnswer = this.answer.length === 0 || this.answer.includes('');
            const belowMin = setNum && (this.answer.length < this.question.numberOfMinAnswers);
            const aboveMax = setNum && (this.question.numberOfMaxAnswers < this.answer.length);
            
            let warningElement = this.ctx.getById(this.shadowRoot, 'warningElement' + this.question.id);
            let errorElement = this.ctx.getById(this.shadowRoot, 'errorElement' + this.question.id);

            if (hasEmptyAnswer && setNum) {
                // Situation 1: no selection - only the generic required message,
                // the min/max hint is reserved for selections below the minimum
                if (warningElement) {
                    warningElement.style.display = 'none';
                    warningElement.textContent = '';
                    warningElement.removeAttribute('lang');
                }
                if (errorElement) {
                    errorElement.classList.add('ph-error');
                    errorElement.textContent = this.question.errorText || (lang === 'en' ? 'Please select an answer.' : 'Bitte w\u00e4hlen Sie eine Antwort aus.');
                }
                this.setAriaInvalid(this.answerContainer);
            } else if (belowMin) {
                // Situation 2: has selection but not reach the minimum - only warning
                if (warningElement) {
                    if (lang === 'en') {
                        const maxText = max ? `, maximum ${max}` : '';
                        warningElement.textContent = `Please select at least ${min}${maxText} answers.`;
                    } else {
                        const maxText = max ? `, maximal ${max}` : '';
                        warningElement.textContent = `W\u00e4hle bitte mindestens ${min}${maxText} Antworten aus.`;
                    }
                    warningElement.style.display = 'block';
                    warningElement.setAttribute('lang', lang);
                }
                if (errorElement) {
                    errorElement.classList.remove('ph-error');
                    errorElement.textContent = '';
                }
                this.setAriaInvalid(this.answerContainer);
            } else if (aboveMax) {
                // Situation 3: has more selections than the maximum - only warning
                if (warningElement) {
                    if (lang === 'en') {
                        warningElement.textContent = `Please select a maximum of ${this.question.numberOfMaxAnswers} answer options.`;
                    } else {
                        warningElement.textContent = `Bitte w\u00e4hlen Sie maximal ${this.question.numberOfMaxAnswers} Antwortoptionen aus.`;
                    }
                    warningElement.style.display = 'block';
                    warningElement.setAttribute('lang', lang);
                }
                if (errorElement) {
                    errorElement.classList.remove('ph-error');
                    errorElement.textContent = '';
                }
                this.setAriaInvalid(this.answerContainer);
            } else {
                if (warningElement) {
                    warningElement.style.display = 'none';
                    warningElement.textContent = '';
                    warningElement.removeAttribute('lang');
                }
                if (errorElement) {
                    errorElement.classList.remove('ph-error');
                    errorElement.textContent = '';
                }
                this.clearAriaInvalid(this.answerContainer);

                this.ctx.goNext(this.question, this.answer);
            }
        });
        return nextButton;
    }

    updateSelectionState() {
        if (!this.question.setNumberOfAnswers) return;
        const max = this.question.numberOfMaxAnswers;
        const reachedMax = max && this.answer.length >= max;
        const warningElement = this.ctx.getById(this.shadowRoot, 'warningElement' + this.question.id);
        const checkboxes = this.answerContainer.querySelectorAll('.ph-input--checkbox');

        if (reachedMax) {
            checkboxes.forEach(cb => {
                if (!cb.checked) {
                    cb.disabled = true;
                    cb.parentElement.style.opacity = '0.5';
                    cb.parentElement.style.cursor = 'not-allowed';
                }
            });
            if (warningElement) {
                const lang = this.ctx.language || 'de';
                warningElement.textContent = lang === 'en' ? `Maximum number of ${max} answers reached.` : `Maximale Anzahl von ${max} Antworten erreicht.`;
                warningElement.style.display = 'block';
            }
        } else {
            checkboxes.forEach(cb => {
                cb.disabled = false;
                cb.parentElement.style.opacity = '1';
                cb.parentElement.style.cursor = 'pointer';
            });
            if (warningElement) {
                const lang = this.ctx.language || 'de';
                const maxReachedText = lang === 'en' ? `Maximum number of ${max} answers reached.` : `Maximale Anzahl von ${max} Antworten erreicht.`;
                if (warningElement.textContent === maxReachedText) {
                    warningElement.style.display = 'none';
                    warningElement.textContent = '';
                }
            }
        }
    }
}
